import { Singleton } from 'framework/di';

/**
 * Cart Drawer Recommendation (RCU) Constants.
 *
 * ## Customization
 * ```javascript
 * window.boostWidgetIntegration.extend('CartDrawerRecommendationConstants', (Base) => {
 *   return class extends Base {
 *     get SELECTORS() {
 *       return { ...super.SELECTORS, CART_MODAL: '#custom-cart-drawer' };
 *     }
 *   };
 * });
 * ```
 */
@Singleton()
export class CartDrawerRecommendationConstants {
  readonly SELECTORS = {
    CART_MODAL: '#boost-sd__modal-cart',
    RECOMMENDATION_CONTAINER: '.boost-sd__recommendation--rcu',
    RECOMMENDATION_BLOCK: '.boost-sd__cart-drawer-recommendation-block',
    PRODUCT_ITEM: '.boost-sd__rcu-item',
    PRODUCT_IMAGE: '.boost-sd__rcu-item-image img',
    PRODUCT_INFO: '.boost-sd__rcu-item-info',
    PRODUCT_PRICE: '.boost-sd__rcu-item-price',
    VARIANT_SELECT: '.boost-sd__rcu-item-variant-select',
    ADD_TO_CART_BUTTON: '.boost-sd__rcu-item-add-btn',
    SLIDER: '.boost-sd__slider',
    SLIDER_CONTAINER: '.boost-sd__slider-container',
    SLIDE: '.boost-sd__slide',
    PREV_BUTTON: '.boost-sd__prev-button',
    NEXT_BUTTON: '.boost-sd__next-button',
    SUCCESS_MESSAGE: '.boost-sd__rcu-item-success',
    ERROR_MESSAGE: '.boost-sd__rcu-item-error',
  } as const;

  readonly CSS_CLASSES = {
    PRODUCT_ITEM: 'boost-sd__rcu-item',
    PRODUCT_INFO: 'boost-sd__rcu-item-info',
    SUCCESS_MESSAGE: 'boost-sd__rcu-item-success',
    ERROR_MESSAGE: 'boost-sd__rcu-item-error',
    BUTTON_LOADING: 'boost-sd__button--loading',
    BUTTON_SUCCESS: 'boost-sd__button--success',
    BUTTON_ERROR: 'boost-sd__button--error',
    RECOMMENDATION_LOADING: 'boost-sd__recommendation--loading',
    SLIDER_DISABLED: 'boost-sd__slider--disabled',
    RECOMMENDATION_RCU_TWO_COLUMNS: 'boost-sd__recommendation--rcu-two-columns',
  } as const;

  readonly DEFAULTS = {
    IMAGE_WIDTH: 300,
  } as const;
}
